import type { GQLLocale } from 'graphql-ts-types';

import { executeQuery } from '../../../gql';
import type { DispatchState } from '../../../types/React';
import type {
  ShowroomResponse,
  ShowroomVariables,
  UseLoadVisualNavigationArgs,
  VisualNavigationItemData,
} from '../../../types/visual-navigation';
import showroomsQuery from '../gql/query/showrooms.gql';
import { transformShowroomItems } from '../transformers/showrooms';

export interface LoadShowroomItemsOptions {
  locale: GQLLocale;
  sku: string;
  setLoaded: DispatchState<boolean>;
  setItems: DispatchState<VisualNavigationItemData[]>;
  setError: DispatchState<Error>;
}

export const getShowroomLoaderParams = ({ sku }: UseLoadVisualNavigationArgs) => ({
  sku,
});

export const loadShowroomItems =
  ({ locale, sku, setLoaded, setItems, setError }: LoadShowroomItemsOptions) =>
  async () => {
    try {
      const { data } = await executeQuery<ShowroomResponse, ShowroomVariables>({
        query: showroomsQuery,
        variables: { sku, locale },
      });

      setItems(transformShowroomItems(data[0].inShowrooms));
    } catch (err) {
      setError(err);
    } finally {
      setLoaded(true);
    }
  };
